import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';
import {ToastService} from '../../../../main/services';
import {TenderAnalyticsSettingsService} from '../../../services';
import {User} from '../../../../auth/models';
import {Tender} from "../../../models";


@Component({
    selector: 'jft-tender-current-contract',
    templateUrl: './tender-current-contract.component.html',
    styleUrls: ['tender-current-contract.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class TenderCurrentContractComponent implements OnInit {
    public loading: boolean = false;
    public form: UntypedFormGroup;
    public missedTenderLocations: [] = [];
    public tender: Tender;

    constructor(
        protected route: ActivatedRoute,
        private service: TenderAnalyticsSettingsService,
        private toast: ToastService,
        private user: User
    ) {

    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        this.tender = this.route.snapshot.parent.parent.data['tender'];
    }

    public onUpdated(uid){
    }

    public save() {

    }
}
